import React from "react";
import bus from "../../../admin-bus";
import { MODAL_OPEN } from "../../../action-types";

const trackOptionControl = ({ hasQuery, onSelection }) => {
  function onAddTrackClick(e) {
    e.preventDefault();

    window
      .fetch("/admin/tracks/new", {
        credentials: "same-origin",
        headers: {
          "X-Requested-With": "XMLHttpRequest"
        }
      })
      .then(response => {
        response.text().then(data => {
          bus.emit(MODAL_OPEN, { content: data, onSuccess: onAddTrackSuccess });
        });
      })
      .catch(error => {
        console.log("Request failed: ", error);
      });
  }

  function onAddTrackSuccess(data) {
    onSelection(data.id, { id: data.id, label: data.label });
  }

  return (
    <div>
      {hasQuery ? (
        <div className="fba-center m-small" style={{ width: "100%" }}>
          <div style={{ width: "100%" }}>
            <p className="fl-left">No matches? Add a new track</p>
            <div className="fl-right pr-medium">
              <button
                className="button button--xsmall button--primary mr-small"
                onClick={e => onAddTrackClick(e)}
              >
                Add track
              </button>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default trackOptionControl;
